import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'loading', templateUrl: './loading.html',
    standalone: false
})
export class LoadingComponent implements AfterViewInit {
  @ViewChild('svg', { static: false }) svgElement: ElementRef;
  color: string;
  @Input('scale') scaleValue: number = 0.9;
  @Input()
  set stroke(color: string) {
    this.color = color;
  }

  ngAfterViewInit(): void {
    this.svgElement.nativeElement.style.stroke = this.color;
  }
}
